<section class="col-md-12 col-sm-12 col-xs-12 dm-no-data-text">
  <img *ngIf="showImage" src="https://PJMUIPROD-dme6d6bhhvcpdvf5.b01.azurefd.net/dmvnext/assets/empty-content.svg"
    alt="No Data Found" />
  <p>{{noDataText}}</p>
</section>
